import * as React from 'react';
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Magnetic as Mi } from "../../styles";
import { Button, ButtonStyle } from '../button/Button';
const Footer = (props) => {
    var _a;
    // button styling will depend on property for each button
    const additionalButtons = (_a = props.additionalButtons) === null || _a === void 0 ? void 0 : _a.map((buttonProps, index) => (React.createElement(Button, Object.assign({ key: buttonProps.id }, buttonProps, { className: buttonProps.style || ButtonStyle.Secondary }))));
    const tertiaryBtn = props.tertiaryBtn && (React.createElement(Button, Object.assign({}, props.tertiaryBtn, { className: ButtonStyle.Tertiary })));
    const secondaryBtn = props.secondaryBtn && (React.createElement(Button, Object.assign({}, props.secondaryBtn, { className: props.secondaryBtn.style ? props.secondaryBtn.style : ButtonStyle.Secondary })));
    const primaryBtn = props.primaryBtn && (React.createElement(Button, Object.assign({}, props.primaryBtn, { className: `${props.primaryBtn.type ? props.primaryBtn.type : ButtonStyle.Primary} mi-spacer__l--base` })));
    const { classes } = props;
    return (React.createElement(Grid, { container: true, justify: "space-between", alignItems: "center", wrap: "nowrap", className: props.isLightbox ? classes.footerLightbox : classes.footer },
        React.createElement(Grid, { container: true },
            tertiaryBtn,
            additionalButtons),
        React.createElement(Grid, { container: true, justify: "flex-end", wrap: "nowrap" },
            secondaryBtn,
            primaryBtn)));
};
export const ModalFooter = withStyles({
    footer: {
        backgroundColor: Mi.colorNeutral02,
        padding: Mi.spacer16,
        flexShrink: 0
    },
    footerLightbox: {
        padding: Mi.spacer16,
        flexShrink: 0
    }
})(Footer);
//# sourceMappingURL=ModalFooter.js.map